import cn from "classnames";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { AiAssistantIcon } from "@/icons/widget-menu";
import { HStack, VStack } from "@/shared/ui/Stack";
import { CREATE_AI_ACTIONS, EDIT_AI_ACTIONS } from "../../constants/aiActions";
import type { CreateSubMenuActions, EditSubMenuActions } from "../../types";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./AiAssistantMenu.module.css";

interface AiAssistantMenuContentProps {
    onCreate: (action: CreateSubMenuActions) => void;
    onEdit: (action: EditSubMenuActions) => void;
    isEditVisible: boolean;
}

export const AiAssistantMenuContent = memo(function AiAssistantMenuContent({
    isEditVisible,
    onCreate,
    onEdit,
}: AiAssistantMenuContentProps) {
    const { t } = useTranslation();
    const titleStyles = cn(styles.item, styles.title);

    return (
        <VStack gap={4} fullWidth align="start">
            <HStack className={styles.heading} gap={12}>
                <AiAssistantIcon />
                {t("aiAssistant.title")}
            </HStack>

            <VStack gap={2} fullWidth align="start">
                <HStack className={titleStyles}>{t("aiAssistant.create")}</HStack>
                {CREATE_AI_ACTIONS.map((item) => {
                    const Icon = item.icon;

                    return (
                        <MenuButton
                            key={item.action}
                            className={styles.button}
                            onClick={() => onCreate(item.action)}
                        >
                            <Icon /> {t(item.titleKey)}
                        </MenuButton>
                    );
                })}

                {isEditVisible && (
                    <>
                        <HStack className={titleStyles}>{t("aiAssistant.editTexts")}</HStack>

                        {EDIT_AI_ACTIONS.map((item) => {
                            const Icon = item.icon;

                            return (
                                <MenuButton
                                    key={item.action}
                                    className={styles.button}
                                    onClick={() => onEdit(item.action)}
                                >
                                    <Icon /> {t(item.titleKey)}
                                </MenuButton>
                            );
                        })}
                    </>
                )}
            </VStack>
        </VStack>
    );
});
